import { useState, useEffect } from 'react';
import { useLocation } from 'react-router';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';
import MuiList from '@mui/material/List';
import { Typography } from '@components/Typography';
import { ListItemButton } from './styles';
import NavigationLink, { isNavigationItemActive } from './NavigationLink';

const MultiLevelItem = ({ item, callback, activeBranch = true, ...bookmarkProps }) => {
    const { children, icon, id, title } = item;
    const [open, setOpen] = useState(false);

    const { pathname } = useLocation();

    const isActive = activeBranch && isNavigationItemActive(item, pathname);

    useEffect(() => {
        if (isActive) {
            setOpen(true);
        }
    }, [pathname, isActive]);

    const handleClick = () => setOpen(prev => !prev);

    return (
        <>
            <ListItemButton
                aria-expanded={open}
                aria-current={isActive ? 'page' : undefined}
                isExpanded={open}
                isActive={isActive}
                type="multi"
                onClick={handleClick}
                id={id}
            >
                <span className="sidebar-active-indicator" />
                {icon}
                <Typography variant="body1">{title}</Typography>
                <div className="sidebar-menu-arrow" aria-hidden="true">
                    {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </div>
            </ListItemButton>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <MuiList component="div" disablePadding>
                    {children.map(child => (
                        <NavigationLink
                            key={child.to}
                            item={child}
                            nested
                            activeBranch={activeBranch}
                            callback={callback}
                            disabled={child.disabled}
                            {...bookmarkProps}
                        />
                    ))}
                </MuiList>
            </Collapse>
        </>
    );
};

export default MultiLevelItem;
